import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  FormControlLabel,
  FormGroup
} from "@material-ui/core"
import React, { useEffect, useState } from "react"
import CustomAlert from "../../../Componentes/Alerts/CustomAlert"
import { useProduct } from "../../../ContextAPI/productContext"
import { useStyles } from "./style"
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import Typography from "@material-ui/core/Typography"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import Topo from "../../../Componentes/TopCategorias"

export default function ModalSelectCategories({ open, onClose }) {
  const classes = useStyles()
  const {
    currentProduct,
    setCurrentProduct,
    categoriesList: contextCategoriesList,
    getCategoriesList
  } = useProduct()
  const [localCategoriesList, setLocalCategoriesList] = useState([])
  const [selectedCategories, setSelectedCategories] = useState([])
  const [showModalAlert, setShowModalAlert] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const [loading, setLoading] = useState(true)


  // Efeito para carregar as categorias quando o modal abrir
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        await getCategoriesList()
      } catch (error) {
        console.error("Erro ao carregar categorias:", error)
      } finally {
        setLoading(false)
      }
    }

    if (open) {
      fetchData()
    }
  }, [open])

  // Efeito para inicializar as categorias selecionadas
  useEffect(() => {
    if (currentProduct?.categories && Array.isArray(currentProduct.categories)) {
      // Converte do formato da API para o formato interno do modal
      const convertedCategories = currentProduct.categories.map(category => {
        const categoryFromList = localCategoriesList.find(
          cat => cat.id === category.id
        )
        return {
          category_id: category.id,
          subcategories_id: category.id_subcategories || [],
          name: categoryFromList?.name || "",
          lojinha_id: categoryFromList?.lojinha_id,
          priority: categoryFromList?.priority,
          subcategories:
            category.id_subcategories?.map(subId => {
              const subcategory = categoryFromList?.subcategories?.find(
                sub => sub.id === subId
              )
              return subcategory ? [subcategory] : []
            }) || []
        }
      })
      setSelectedCategories(convertedCategories)
    } else {
      setSelectedCategories([])
    }
  }, [currentProduct, localCategoriesList])

  // Efeito para atualizar a lista local quando o contexto mudar
  useEffect(() => {
    if (contextCategoriesList && Array.isArray(contextCategoriesList)) {
      setLocalCategoriesList(contextCategoriesList)
    }
  }, [contextCategoriesList])

  const isCategorySelected = categoryId => {
    const category = selectedCategories?.find(cat => cat.category_id === categoryId)
    return category !== undefined
  }

  const isCategorySelectedWithoutSubcategories = categoryId => {
    const category = selectedCategories?.find(cat => cat.category_id === categoryId)
    return (
      category &&
      Array.isArray(category.subcategories_id) &&
      category.subcategories_id.length === 1 &&
      category.subcategories_id[0] === null
    )
  }

  const isSubcategorySelected = (categoryId, subcategoryId) => {
    const category = selectedCategories?.find(cat => cat.category_id === categoryId)
    return (
      category &&
      Array.isArray(category.subcategories_id) &&
      category.subcategories_id.includes(subcategoryId)
    )
  }

  const handleChangeJustCategory = category => {
    setSelectedCategories(prev => {
      const exists = prev.find(cat => cat.category_id === category.id)
      if (exists) {
        return prev.filter(cat => cat.category_id !== category.id)
      } else {
        const newCategory = {
          category_id: category.id,
          subcategories_id: [null],
          name: category.name,
          lojinha_id: category.lojinha_id,
          priority: category.priority,
          subcategories: []
        }
        return [...prev, newCategory]
      }
    })
  }

  const handleClickSub = (subcategory, category) => {
    setSelectedCategories(prev => {
      const categoryIndex = prev.findIndex(cat => cat.category_id === category.id)

      if (categoryIndex === -1) {
        return [
          ...prev,
          {
            category_id: category.id,
            subcategories_id: [subcategory.id],
            name: category.name,
            lojinha_id: category.lojinha_id,
            priority: category.priority,
            subcategories: [[subcategory]]
          }
        ]
      }

      const updatedCategories = [...prev]
      const currentCategory = { ...updatedCategories[categoryIndex] }

      if (!currentCategory.subcategories_id) {
        currentCategory.subcategories_id = []
      }

      const subIndex = currentCategory.subcategories_id.indexOf(subcategory.id)

      if (subIndex === -1) {
        currentCategory.subcategories_id.push(subcategory.id)
        if (!currentCategory.subcategories) {
          currentCategory.subcategories = []
        }
        currentCategory.subcategories.push([subcategory])
      } else {
        currentCategory.subcategories_id.splice(subIndex, 1)
        currentCategory.subcategories.splice(subIndex, 1)
      }

      if (currentCategory.subcategories_id.length === 0) {
        return prev.filter(cat => cat.category_id !== category.id)
      }

      updatedCategories[categoryIndex] = currentCategory
      return updatedCategories
    })
  }

  const handleSave = () => {
    // Transforma o formato das categorias para o formato que a API espera
    const formattedCategories = selectedCategories.map(category => ({
      id: category.category_id,
      id_subcategories: Array.isArray(category.subcategories_id)
        ? category.subcategories_id
        : []
    }))

    setCurrentProduct(prev => ({
      ...prev,
      categories: formattedCategories
    }))
    setShowModalAlert(true)
    setTimeout(() => {
      setShowModalAlert(false)
      onClose()
    }, 1500)
  }

  return (
    <Dialog className={classes.Modal} open={open}>
      {loading ? (
        <div
          style={{
            backgroundColor: " #fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%"
          }}
        >
          <CircularProgress color="secondary" size="40px" />
        </div>
      ) : (
        <div className="page-container">
          <div className="page-align">
            <Topo handleClose={onClose} name="Categorias e subcategorias" />
            <div className="infinite-scroll">
              <FormGroup>
                {!localCategoriesList || localCategoriesList.length === 0 ? (
                  <p style={{ paddingTop: "20px" }}>
                    Você ainda não possui categorias cadastradas para os seus
                    produtos.
                  </p>
                ) : (
                  localCategoriesList.map((category, index) => {
                    const isCategorySelected = selectedCategories?.some(
                      cat => cat.category_id === category.id
                    )

                    return (
                      <div key={category.id}>
                        <Accordion
                          key={category.id}
                          expanded={expanded === index}
                          style={{ backgroundColor: "#F3F3F3", margin: "10px" }}
                          onChange={() =>
                            setExpanded(prev => (prev === index ? false : index))
                          }
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel-${category.id}-content`}
                            id={`panel-${category.id}-header`}
                          >
                            <Typography>{category.name}</Typography>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={isCategorySelectedWithoutSubcategories(
                                      category.id
                                    )}
                                    onChange={() =>
                                      handleChangeJustCategory(category)
                                    }
                                    name={`justCategory_${category.id}`}
                                    value={category.id}
                                  />
                                }
                                label="Selecionar apenas essa categoria"
                              />
                            </div>
                            {category.subcategories &&
                              category.subcategories.length > 0 &&
                              category.subcategories.map(subcategory => (
                                <div key={subcategory.id}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={() =>
                                          handleClickSub(subcategory, category)
                                        }
                                        checked={isSubcategorySelected(
                                          category.id,
                                          subcategory.id
                                        )}
                                        name={subcategory.id}
                                        value={subcategory.id}
                                        disabled={
                                          isCategorySelected &&
                                          selectedCategories?.find(
                                            cat => cat.category_id === category.id
                                          )?.subcategories_id?.length === 0
                                        }
                                      />
                                    }
                                    label={subcategory.sub_name}
                                    style={{
                                      marginBottom: "10px"
                                    }}
                                  />
                                </div>
                              ))}
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )
                  })
                )}
              </FormGroup>
            </div>
            <div className="footer-column">
              <hr style={{ width: "100%", margin: "20px 0" }} />
              <Button
                className={classes.btnFooterPink}
                onClick={() => handleSave()}
                fullWidth
                variant="contained"
                color="secondary"
              >
                Salvar e sair
              </Button>
            </div>
          </div>
        </div>
      )}
      {showModalAlert ? (
        <CustomAlert
          type="success"
          alertText="Categorias selecionadas com sucesso!"
          show={showModalAlert}
          close={() => setShowModalAlert(false)}
        />
      ) : null}
    </Dialog>
  )
}
